import { IssSchemaTypes } from "@bfc-software/api-schemas";
import { getEnv } from "@bfc-software/bfc-web-ui/environment";
import {
  aaaTokenOrToken,
  useAuthenticatedApi,
  useAuthenticatedFetchClient,
} from "@bfc-software/bfc-web-ui/lib/authenticated-api";

type Paths = IssSchemaTypes.paths;

const spec = () => ({
  baseUrl: `${getEnv().issServiceBaseUrl}/v1`,
  select: aaaTokenOrToken,
});

export const useIssApi = () => useAuthenticatedApi<Paths>(spec());

/** Stable client for imperative use (callbacks, queryFn). Rebuilt only when the token changes. */
export const useIssFetchClient = () =>
  useAuthenticatedFetchClient<Paths>(spec());
